var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Github",
    clipPath: "url(#clip0_35_59)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M5.99999 12.6667C2.66666 13.6667 2.66666 11 1.33333 10.6667M10.6667 14.6667V12.0867C10.6917 11.7688 10.6487 11.4492 10.5407 11.1492C10.4326 10.8492 10.2619 10.5756 10.04 10.3467C12.1333 10.1133 14.3333 9.32 14.3333 5.68C14.3332 4.74922 13.9751 3.85413 13.3333 3.18C13.6372 2.36567 13.6157 1.46557 13.2733 0.666666C13.2733 0.666666 12.4867 0.433332 10.6667 1.65333C9.13867 1.23921 7.52799 1.23921 5.99999 1.65333C4.17999 0.433332 3.39333 0.666666 3.39333 0.666666C3.05091 1.46557 3.02942 2.36567 3.33333 3.18C2.68675 3.85913 2.32834 4.76231 2.33333 5.7C2.33333 9.31333 4.53333 10.1067 6.62666 10.3667C6.40733 10.5933 6.23817 10.8636 6.1302 11.1599C6.02223 11.4563 5.97787 11.772 5.99999 12.0867V14.6667",
    stroke: "#1E1E1E",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_35_59"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/Github.58d95293b1d055fddf601ca87eac006a.svg";
export { ForwardRef as ReactComponent };